var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PencilSimple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9827 5.15887L12.8412 2.01661C12.7367 1.91211 12.6127 1.82922 12.4762 1.77267C12.3397 1.71612 12.1933 1.68701 12.0456 1.68701C11.8978 1.68701 11.7515 1.71612 11.615 1.77267C11.4785 1.82922 11.3545 1.91211 11.25 2.01661L2.57977 10.6875C2.47485 10.7916 2.39167 10.9155 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.625C2.25001 14.9234 2.36853 15.2096 2.57951 15.4205C2.79049 15.6315 3.07664 15.75 3.37501 15.75H6.51727C6.66506 15.7505 6.81147 15.7216 6.94799 15.665C7.08451 15.6084 7.20842 15.5252 7.31251 15.4203L15.9827 6.75004C16.0872 6.64558 16.1701 6.52154 16.2267 6.38504C16.2832 6.24853 16.3123 6.10222 16.3123 5.95446C16.3123 5.8067 16.2832 5.66039 16.2267 5.52388C16.1701 5.38737 16.0872 5.26334 15.9827 5.15887ZM6.51727 14.625H3.37501V11.4828L9.56251 5.29528L12.7048 8.43754L6.51727 14.625ZM13.5 7.64161L10.3577 4.50004L12.0452 2.81254L15.1875 5.95411L13.5 7.64161Z",
    fill: "#F4F4F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconGrey);
export default __webpack_public_path__ + "static/media/EditIconGrey.5d7c2ec3307d49529ea200bc2978139c.svg";
export { ForwardRef as ReactComponent };